import { render, staticRenderFns } from "./CompanyTab.vue?vue&type=template&id=778bf334&scoped=true&"
import script from "./CompanyTab.vue?vue&type=script&lang=js&"
export * from "./CompanyTab.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTab.vue?vue&type=style&index=0&id=778bf334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bf334",
  null
  
)

export default component.exports